export const ONLINE = 4
export const BUSY = 1
export const INVISIBLE = 2
export const BERIGHTBACK = 3
export const OFFLINE = 0
